module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/470.56bebed3.png";